import { baseApi } from '../../../shared/api/baseApi';
import type { SupplierDownloadDto } from '../model/dto';
import { toSupplierDownload } from '../model/mappers';
import type { SupplierDownload } from '../model/types';

const ENDPOINT = '/api/download_suppliers';

const TAG = 'SupplierDownload' as const;

export const supplierDownloadApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getSupplierDownloadStatus: build.query<SupplierDownload, void>({
            query: () => `${ENDPOINT}/last_update`,
            transformResponse: (response: SupplierDownloadDto) => toSupplierDownload(response),
            providesTags: [{ type: TAG, id: 'STATUS' }],
        }),

        startSupplierDownload: build.mutation<unknown, void>({
            query: () => ({ url: ENDPOINT, method: 'GET' }),
            invalidatesTags: [{ type: TAG, id: 'STATUS' }],
        }),
    }),
    overrideExisting: false,
});

export const { useGetSupplierDownloadStatusQuery, useStartSupplierDownloadMutation } = supplierDownloadApi;